export type ProjectOversightMode = 'assessment' | 'chat' | 'report';

export type ProjectOversightPageConfig = {
  topBarTitle: string;
  toolbarTitle: string;
  toolbarDesc: string;
  recordsPanelLabel: string;
  recordNoun: string;
  recordNounPlural: string;
  emptyRecordsTitle: string;
  emptyRecordsHint: string;
  selectProjectHint: string;
};

export const PROJECT_OVERSIGHT_CONFIG: Record<ProjectOversightMode, ProjectOversightPageConfig> = {
  assessment: {
    topBarTitle: 'Project Assessments',
    toolbarTitle: 'Client assessments',
    toolbarDesc:
      'Select a company and project to review each client’s assessment. Open a record for full detail.',
    recordsPanelLabel: 'Assessments',
    recordNoun: 'assessment',
    recordNounPlural: 'assessments',
    emptyRecordsTitle: 'No client assessments yet',
    emptyRecordsHint:
      'When clients complete assessments, each client’s submission will appear here for this project.',
    selectProjectHint: 'Select a project to view client assessments.',
  },
  chat: {
    topBarTitle: 'Project Chats',
    toolbarTitle: 'Client & SME chats',
    toolbarDesc:
      'Select a company and project to review chat threads per client. Open a conversation for full detail.',
    recordsPanelLabel: 'Conversations',
    recordNoun: 'conversation',
    recordNounPlural: 'conversations',
    emptyRecordsTitle: 'No client chats yet',
    emptyRecordsHint:
      'When clients and SMEs exchange messages, each client conversation will appear here.',
    selectProjectHint: 'Select a project to view client conversations.',
  },
  report: {
    topBarTitle: 'Project Reports',
    toolbarTitle: 'Project reports',
    toolbarDesc:
      'Select a company and project to view generated reports shared across the project team.',
    recordsPanelLabel: 'Reports',
    recordNoun: 'report',
    recordNounPlural: 'reports',
    emptyRecordsTitle: 'No reports generated yet',
    emptyRecordsHint:
      'When reports are generated for this project, they will appear here for Super Admin review.',
    selectProjectHint: 'Select a project to view generated reports.',
  },
};
